import CryptoJS from "crypto-js";

const SECRET_KEY = "your-secret-key"; // Keep this in env

// Encrypt ID
export const encryptId = (id: number) => {
  return CryptoJS.AES.encrypt(id.toString(), SECRET_KEY).toString();
};

// Decrypt ID
export const decryptId = (cipherText: string) => {
  const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY);
  return bytes.toString(CryptoJS.enc.Utf8);
};

export const generateSlug = (title: string): string => {
  return title
    .toLowerCase()                         // lowercase
    .replace(/[^a-z0-9\s-]/g, '')          // remove special chars
    .trim()                                // remove leading/trailing spaces
    .replace(/\s+/g, '-')                  // replace spaces with dashes
    .replace(/-+/g, '-');                  // collapse multiple dashes
};